import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * NOTE: This standalone component is now deprecated.
 * The Add Student functionality has been integrated directly into the Students.tsx page
 * as a popup modal to match the design of the Moderator management.
 * 
 * Please use the "Add New Student" button on the Students page to add new students.
 */

const AddStudent = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-dark">Add New Student</h1>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-yellow-700">
                This standalone page is deprecated. The Add Student functionality has been moved to the Students page as a popup modal.
              </p>
              <p className="mt-2 text-sm">
                <button
                  type="button"
                  onClick={() => navigate('/students')}
                  className="font-medium text-yellow-700 underline hover:text-yellow-600"
                >
                  Go to Students page
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddStudent; 